(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sideCart = document.querySelector('#sideCart');
    const cartRecommendationsContainer = sideCart.querySelector('.cart__recommendations');

    // Function to update cart recommendations
    const updateCartRecommendations = (productId, productHandle) => {
      if (!productId) return;

      // fetch(`/products/${productHandle}.js`)
      //   .then(response => {
      //     console.log(response);
      //     if (!response.ok) throw new Error('Failed to fetch recommendations');
      //     return response.text();
      //   })
      //   .then(html => {
      //     // Update the recommendations container with new content
      //     cartRecommendationsContainer.innerHTML = html;
      //   })
      //   .catch(error => console.error('Error fetching recommendations:', error));

      fetch(`/recommendations/products?section_id=cart-recommendations&product_id=${productId}&limit=4&intent=complementary`)
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch recommendations');
          return response.text();
        })
        .then(html => {
          if (containsProducts(html)) {
            // Update the recommendations container with new content
            cartRecommendationsContainer.innerHTML = html;
            initSwiper();
          } else {
            loadFallbackRecommendations(productId);
          }
          
        })
        .catch(error => console.error('Error fetching recommendations:', error));
    };

    function loadFallbackRecommendations(productId) {
      const relatedProductsUrl = `/recommendations/products?section_id=cart-recommendations&product_id=${productId}&limit=4&intent=related`;
      fetch(relatedProductsUrl)
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch recommendations');
          return response.text();
        })
        .then(html => {
          cartRecommendationsContainer.innerHTML = html;
          initSwiper();
        })
        .catch(error => console.error('Error fetching related products:', error));
    }

    // Event listener for adding a product to the cart
    document.querySelectorAll('.add-to-cart-button').forEach(button => {
      
      button.addEventListener('click', (event) => {
        const productId = button.getAttribute('data-product'); // Ensure the button has a data-product-id attribute
        const productHandle = button.getAttribute('data-handle'); // Ensure the button has a data-product-handle attribute

        updateCartRecommendations(productId, productHandle);
      });
    });

    document.querySelectorAll('.product-form__submit[name="add"]').forEach(button => {
      button.addEventListener('click', (event) => {
        const productId = button.getAttribute('data-product'); // Ensure the button has a data-product-id attribute
        const productHandle = button.getAttribute('data-handle'); // Ensure the button has a data-product-handle attribute

        updateCartRecommendations(productId, productHandle);
      });
    });
  });

  function containsProducts(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return !!doc.querySelector('.grid.product-grid .grid__item'); // Adjust selector to match your product structure
  }

  function initSwiper() {
    var recommendSwiper = new Swiper(".cart-recommendations-swiper", {
          slidesPerView: 2.5,
          spaceBetween: 10,
          navigation: {
            nextEl: ".cart-recommendations-swiper .recommended-button-next",
            prevEl: ".cart-recommendations-swiper .recommended-button-prev",
          },
          breakpoints: {
            640: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
        var productSwiper__slidecount = recommendSwiper.slides.length;
          if (productSwiper__slidecount < 3) {
            document.querySelector('.cart-recommendations-swiper .recommended-button-next').classList.add('visually-hidden');
            document.querySelector('.cart-recommendations-swiper .recommended-button-prev').classList.add('visually-hidden');
          }
  }

  class CartRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('cart-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              initSwiper();
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('cart-recommendations--loaded');
            } else {
              fetch(this.dataset.urlRelated)
                .then(response => response.text())
                .then(text => {
                  const html = document.createElement('div');
                  html.innerHTML = text;
                  const recommendations = html.querySelector('cart-recommendations');

                  if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                  }

                  if (html.querySelector('.grid__item')) {
                    this.classList.add('cart-recommendations--loaded');
                  }
                  initSwiper();
                })
                .catch(e => {
                  console.error(e);
                });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
